import { ReactNode } from 'react'
import { cn } from '@utils/cn'

interface FormModalProps {
  readonly isOpen: boolean
  readonly onClose: () => void
  readonly title?: string
  readonly children: ReactNode
  readonly className?: string
  readonly id?: string
}

export function FormModal({ isOpen, onClose, title, children, className, id }: Readonly<FormModalProps>) {
  if (!isOpen) return null

  const handleBackdropKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Escape') {
      onClose()
    }
  }

  return (
    <div 
      id={id}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
      onClick={onClose}
      onKeyDown={handleBackdropKeyDown}
      role="dialog"
      aria-modal="true"
      aria-labelledby={title ? "form-modal-title" : undefined}
      tabIndex={-1}
    >
      <div
        className={cn(
          'bg-transparent max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto',
          className
        )}
        onClick={(e) => e.stopPropagation()}
        role="document"
      >
        {/* Content sem padding branco - o formulário já tem seu próprio estilo */}
        <div className="relative">
          {children}
        </div>
      </div>
    </div>
  )
}
